import React, { useContext } from "react";
// Common Components
import TabBox, { Tab } from "src/Components/Tabbox/TabBox";
// Local Components
import BaseHedgerPair from "./BaseHedgerPair/BaseHedgerPair";
import Calculation from "./Calculation/Calculation";
import IVOption from "./IVOption/IVOption";
import Execusion from "./Execusion/Execusion";
import IVPut from "./IVPut/IVPut";
import DeltaCalculations from "./DeltaCalculations/DeltaCalculations";
import { useSearchParams } from "react-router-dom";
import { ServerTabsContext } from "src/Layout/MasterPage";
import ServerTabBox from "src/Components/Tabbox/ServerTabBox";

enum ActiveTab {
  BaseHedgerPair = "BaseDefinitionHex",
  Calculation = "Calculations",
  IVOption = "CallChainIV",
  IVPut = "PutChainIV",
  Execusion = "MarketExecution",
  DeltaCalculations = "DeltaCalculations",
}

const AutomaticMarketMaking: React.FC = () => {
  const [searchParams] = useSearchParams({
    activeTab: ActiveTab.BaseHedgerPair,
  });
  const tabs = useContext(ServerTabsContext).automaticMarketMaking;
  const activeTab = searchParams.get("activeTab") || "#";

  return (
    <div className="flex flex-col justify-start items-start gap-2 relative min-h-screen pt-5 mx-auto p-8 w-full">
      <div className="w-1/3">
        <ServerTabBox children={tabs?.tabs} />
      </div>
      {activeTab === ActiveTab.BaseHedgerPair ? <BaseHedgerPair /> : <></>}
      {activeTab === ActiveTab.Calculation ? <Calculation /> : <></>}
      {activeTab === ActiveTab.IVOption ? <IVOption /> : <></>}
      {activeTab === ActiveTab.IVPut ? <IVPut /> : <></>}
      {activeTab === ActiveTab.Execusion ? <Execusion /> : <></>}
      {activeTab === ActiveTab.DeltaCalculations ? <DeltaCalculations /> : <></>}
    </div>
  );
};

export default AutomaticMarketMaking;
